import { action, computed, makeObservable } from 'mobx';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {McqModel, McqMultiSelectState} from '../models';

export class MultiSelectMcqStore {
  constructor(readonly id: number,
              readonly model: McqModel,
              readonly stateStore: X9ContentStateStore) {
    makeObservable(this);
  }

  @computed
  get state(): McqMultiSelectState | null {
    const states = Array(this.model.choices.length).fill({selectedIndex: null, checked: false});
    const altStates: McqMultiSelectState = { states };
   
    return this.stateStore.getContentState<McqMultiSelectState>(this.id) ? this.stateStore.getContentState<McqMultiSelectState>(this.id) : altStates;
  }

  @action
  toggle = (index: number) => {
    if (this.state === null)
      return;
    const states = this.state.states.slice();
    const state = states[index];
    states[index] = {selected: !state.selected, checked: false};
    this.stateStore.setContentState<McqMultiSelectState>(
      this.id, {states: states});
  };

  @action
  check = () => {
    if (this.state === null)
      return;
    const states = this.state.states.slice();

    for (let index = 0; index < states.length; index++) {
      const state = states[index];
      states[index] = {selected: state.selected, checked: true};
    }

    this.stateStore.setContentState<McqMultiSelectState>(this.id, {states: states});
  };

}

